import { Injectable, NgZone, OnDestroy } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class DemoPageFocusService implements OnDestroy {
  private isPageFocused$ = new BehaviorSubject<boolean>(!document.hidden);

  constructor(private ngZone: NgZone) {
    this.ngZone.runOutsideAngular(() => {
      const onFocus$ = fromEvent(window, 'focus').pipe(map(() => true));
      const onBlur$ = fromEvent(window, 'blur').pipe(map(() => false));
      const onVisibilityChange$ = fromEvent(document, 'visibilitychange').pipe(
        map(() => !document.hidden)
      );

      merge(onFocus$, onBlur$, onVisibilityChange$)
        .pipe(startWith(!document.hidden), debounceTime(200))
        .subscribe(isFocused => {
          this.ngZone.run(() => this.isPageFocused$.next(isFocused));
        });
    });
  }

  get focusChanges$(): Observable<boolean> {
    return this.isPageFocused$.asObservable();
  }

  ngOnDestroy(): void {
    this.isPageFocused$.complete();
  }
}
